import type { ShopifyRouter } from "replo-publisher/src/trpc/routers/shopify";

import { createTrpcRouterConfig } from "@v2/trpc/config";
import { getNamespacedQueryClient } from "@v2/trpc/trpc";

const {
  router: shopifyRouter,
  client: shopifyClient,
  utils: shopifyUtils,
  options: shopifyOptions,
} = createTrpcRouterConfig<ShopifyRouter>({
  path: "shopify",
  queryClient: getNamespacedQueryClient("shopify"),
});

export { shopifyClient, shopifyRouter, shopifyUtils, shopifyOptions };
